import React from "react";

import { LogUnionRowItem } from "@common/components/MasterTable/models/MasterTableModel";
import { getActivityHistoryCellStyle, isCellError } from "@common/components/ShakeTable/ui/activityHistory/DomainCell";
import { BaseCell } from "@common/components/ShakeTable/ui/BaseCell";
import { vars } from "@common/styles";
import { CellContext } from "@tanstack/react-table";

interface TimestampCellProps {
  info: CellContext<LogUnionRowItem, string>;
}

const TimestampCell = ({ info }: TimestampCellProps) => {
  const item = info.row.original;
  if (!item) return null;

  const prettifiedTime: string = prettifyTimestampTime(info.getValue());

  const timeValues: string[] = prettifiedTime.split(".");
  const time: string = timeValues[0];
  const millis: string = timeValues[1];

  const isError = isCellError(info);

  return (
    <BaseCell
      style={getActivityHistoryCellStyle(isError)}
      withBorder={info.table.getSelectedRowModel()?.rows[0]?.index - 1 === info.row.index || info.row.getIsSelected()}
    >
      {time}
      <span
        style={{ color: isCellError(info) ? vars.colors.red : vars.colors.grey60, fontSize: 12 }}
      >{`.${millis}`}</span>
    </BaseCell>
  );
};

const prettifyTimestampTime = (reportedTimestamp: string): string => {
  const date = new Date(reportedTimestamp);

  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");
  const milliseconds = date.getMilliseconds().toString().padStart(3, "0");

  return `${hours}:${minutes}:${seconds}.${milliseconds}`;
};

export { TimestampCell };
